// react
import React from 'react'

// components
import { Table, Button } from '@st-operations/uikit/src/v2/index.js'

// constants
import end_points from '../constants/endpoints.js'
import Cookies from '_lib/cookies'

const handleSampleClick = (url) => {
  const token = Cookies.getCookie('token')
  fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((resp) => resp.json())
    .then((data) => {
      const newWindow = window.open('', '_blank')
      newWindow.document.write('<pre>' + JSON.stringify(data, null, 2) + '</pre>')
    })
    .catch((error) => {
      alert('Error: ' + error.message)
    })
}

const columns = [
  {
    name: 'Method',
    key: 'method',
    width: 150,
  },
  {
    name: 'URL',
    key: 'url',
    width: 220,
  },
  {
    name: 'Query Params',
    key: 'query_params',
  },
  {
    name: 'Sample response',
    key: 'sample',
    render: (item) => {
      if (item.sample) {
        return <Button onClick={() => handleSampleClick(item.sample)} text="Test" size="small" >Link</Button>
      }
      return '-'
    },
  },
]

class ApiPage extends React.Component {
  render() {
    return (
      <div>
        <h1>DataSphere API Documentation</h1>
        <For each="endpoint" of={Object.keys(end_points)}>
          <section key={endpoint}>
            <h2>{endpoint.replace('_', ' ')}</h2>
            <Table columns={columns} data={end_points[endpoint]} />
          </section>
        </For>
      </div>
    )
  }
}

export default ApiPage
